import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { Media, Product, NGXLogger } from '@app/shared';
import { ProductService } from '@app/core';
import {
  ProductActionTypes,
  GetProducts,
  GetProductsSuccess,
  GetProductsFailure,
  SetProduct,
  SetProductSuccess,
  SetProductFailure,
  GetProductMedia,
  GetProductMediaSuccess,
  GetProductMediaFailure,
  GetAllProductsMedia,
  GetAllProductsMediaSuccess,
  GetAllProductsMediaFailure,
} from '../actions/product.actions';


@Injectable()
export class ProductEffects {

  constructor(
    private actions: Actions,
    private productService: ProductService,
    private router: Router,
    private logger:NGXLogger,
  ) { }

    @Effect()
    GetProducts: Observable<any> = this.actions
        .ofType(ProductActionTypes.GET_PRODUCTS)
        .debounceTime(200)
        .map((action: GetProducts) => action.payload)
        .switchMap(payload => {
          return this.productService.getProducts(payload.searchCriteria.keyword,payload.searchCriteria.includeAssets)
            .map((result) => {

              let prods = [];
              // init product members
              result.data.map(product => {
                let prod = Object.assign( new Product(), product );
                let arr = [];
                if(prod.productassets){
                  prod.productassets.map(asset => {

                      if(asset.media){
                        let val:Media = Object.assign( new Media(), asset.media );
                        arr.push({media:val});
                      }

                    }
                  )
                  prod.productassets = arr;
                }

                prods.push(prod);
              });

              return new GetProductsSuccess({products:prods,searchCriteria:payload.searchCriteria})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetProductsFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetProductsSuccess: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.GET_PRODUCTS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetProductsFailure: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.GET_PRODUCTS_FAILURE)
    );


    // SETTING CURRENT Product
  //  @Effect()
    /*SetProduct: Observable<any> = this.actions
        .ofType(ProductActionTypes.SET_PRODUCT)
        .map((action: GetProducts) => action.payload)
        .switchMap(payload => {
          return this.productService.getProduct(payload.product)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetProductSuccess({selectedProduct:payload.product})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetProductFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetProductSuccess: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.SET_PRODUCT_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetProductFailure: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.SET_PRODUCT_FAILURE)
    );


    @Effect()
    GetProductMedia: Observable<any> = this.actions
        .ofType(ProductActionTypes.GET_PRODUCT_MEDIA)
        .map((action: GetProductMedia) => action.payload)
        .switchMap(payload => {
          return this.productService.getProductMedia(payload.product.uuid)
            .map((result) => {
              //console.log('success');
              payload.product.media = [];
              payload.product.media = result.medias.map(media => {
                let tmpMedia = Object.assign( new Media(), media );
                if(tmpMedia.thumbUrl === payload.product.heroMediaURL){
                  tmpMedia.isHero = true;
                }
                return tmpMedia;

              })
              return new GetProductMediaSuccess({product:payload.product})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetProductMediaFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetProductMediaSuccess: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.GET_PRODUCT_MEDIA_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetProductMediaFailure: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.GET_PRODUCT_MEDIA_FAILURE)
    );

    ////////////////////////////
    //
    // All Products Media
    //
    ////////////////////////////
    @Effect()
    GetAllProductsMedia: Observable<any> = this.actions
        .ofType(ProductActionTypes.GET_ALL_PRODUCTS_MEDIA)
        .map((action: GetAllProductsMedia) => action.payload)
        .switchMap(payload => {
          return this.productService.getAllProductsMedia(payload.products,payload.offer.uuid)
            .map((result) => {
              //console.log('success',result);
              for(var i = 0; i < payload.products.length; i++){
                var product = payload.products[i];
                var medias = result[i].medias?result[i].medias:[];

                product.media = medias.map(media => {
                  let tmpMedia = Object.assign( new Media(), media );
                  tmpMedia.selected = media.selectedMedia;
                  tmpMedia.originOwner = `Product_${media.uuid}`;
                  // if(tmpMedia.thumbUrl === product.heroMediaURL){
                  //   tmpMedia.isHero = true;
                  // }
                  return tmpMedia;

                })
              }
              // payload.product.media = [];
              // payload.product.media = result.medias.map(media => {
              //   let tmpMedia = Object.assign( new Media(), media );
              //   if(tmpMedia.thumbUrl === payload.product.heroMediaURL){
              //     tmpMedia.isHero = true;
              //   }
              //   return tmpMedia;
              //
              // })
              return new GetAllProductsMediaSuccess({products:payload.products})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetAllProductsMediaFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetAllProductsMediaSuccess: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.GET_ALL_PRODUCTS_MEDIA_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetAllProductsMediaFailure: Observable<any> = this.actions.pipe(
      ofType(ProductActionTypes.GET_ALL_PRODUCTS_MEDIA_FAILURE)
    );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/product.effects.ts